import React from "react";

const CobbAngle = ({color}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="0.346638"
        y="0.587893"
        width="7.60257"
        height="3.4293"
        rx="1.5"
        transform="matrix(0.976248 0.216657 -0.282971 0.959128 1.4285 14.6628)"
        fill={color}
        stroke={color}
        strokeLinejoin="round"
      />
      <rect
        y="0.655208"
        width="7.11409"
        height="3.73249"
        rx="1.5"
        transform="matrix(0.755449 0.655208 -0.755449 0.655208 9.17662 4.72493)"
        fill={color}
        stroke={color}
        strokeLinejoin="round"
      />
      <rect
        x="19.4434"
        y="7.01855"
        width="6.51855"
        height="4.05603"
        rx="1.5"
        transform="rotate(-90 19.4434 7.01855)"
        fill={color}
        stroke={color}
        strokeLinejoin="round"
      />
      <ellipse
        cx="3.37798"
        cy="22.5"
        rx="1.72954"
        ry="1.50005"
        fill={color}
      />
      <ellipse
        cx="6.83696"
        cy="13.5"
        rx="1.72954"
        ry="1.50005"
        fill={color}
      />
      <ellipse
        cx="15.4854"
        cy="5.99907"
        rx="1.72954"
        ry="1.50005"
        fill={color}
      />
    </svg>
  );
};

export default CobbAngle;
